import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { NavigationService } from '@app/services/navigation';
import { NavigationRoute } from '@app/services/navigation/models';

@Component({
    selector: 'component-header-basket-builder',
    templateUrl: './header-basket-builder.component.html',
    styleUrls: ['./header-basket-builder.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HeaderBasketBuilderComponent implements OnInit, OnDestroy {
    public searchText = '';

    public showBackButton: boolean = false;

    private routeSubscription: Subscription;

    constructor(
        private navigationService: NavigationService
    ) { }

    ngOnInit() {
        this.routeSubscription = this.navigationService.route.subscribe(
            (route: NavigationRoute) => {
                if (route.segments.indexOf('basket-builder') !== -1) {
                    this.showBackButton = false;
                } else {
                    this.showBackButton = true;
                }
            }
        )
    }

    ngOnDestroy() {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
            this.routeSubscription = null;
        }
    }

    public closeSearch() {
        this.searchText = '';
    }
}
